/* as.if.club (25.09.2026)
   Kostenlose Mitgliedschaft mit dem Shopify-Kundenkonto.
   1. Merkliste fuer Produkte und Artikel (Herz-Knoepfe mit data-asif-club-save),
      fuer alle, ohne Konto nur auf diesem Geraet.
   2. Abgleich fuer Mitglieder: Radio-Favoriten, gemerkte Mixtapes und Merkliste
      liegen im Kundenkonto (Metafelder asif_club.*) und kommen auf jedes Geraet.
      Server: club.as-if-records.com (Cloudflare Worker asif-club).
   3. Beitritt: Dialog im Stil einer Clubtuer, Anmeldung per Mail-Code bei Shopify.
   4. Clubseite /pages/club: Listen, Beitritt, Austritt.
   Keine Titel-Exporte, keine Dateien: der Abgleich laeuft nur im Konto. */
(() => {
  'use strict';
  if (window.AsIfClub) return;

  // Konfiguration steht im Kopf jeder Seite. Beim weichen Seitenwechsel der App
  // tauscht asif-spa.js den Knoten aus, dann wird sie neu gelesen (Token, Rev).
  const parseConfig = text => { try { const v = JSON.parse(text || '{}'); return v && typeof v === 'object' ? v : {}; } catch { return {}; } };
  const readConfig = () => parseConfig(document.getElementById('asif-club-config')?.textContent);
  let cfg = readConfig();

  const KEYS = {
    favorites: 'asif_radio_favorites_v1',
    recordings: 'asif.radio.saved-recordings.v1',
    wishlist: 'asif.club.wishlist.v1',
    snapshot: 'asif.club.snapshot.v1',
    hints: 'asif.club.hints.v1',
    from: 'asif.club.from',
    intent: 'asif-account-login-intent'
  };
  const LIMIT = { wishlist: 100 };

  const store = {
    get(key, fallback) { try { const raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : fallback; } catch { return fallback; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } }
  };
  const session = {
    get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch {} }
  };
  const esc = value => String(value ?? '').replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

  /* ------------------------------------------------------------ Listen */
  const lists = {
    favorites: () => { const v = store.get(KEYS.favorites, []); return Array.isArray(v) ? v : []; },
    recordings: () => { const v = store.get(KEYS.recordings, {}); return v?.version === 1 && Array.isArray(v.entries) ? v.entries : []; },
    wishlist: () => { const v = store.get(KEYS.wishlist, {}); return v?.version === 1 && Array.isArray(v.entries) ? v.entries : []; }
  };
  const keyOf = {
    favorites: item => item.id,
    recordings: item => item.url,
    wishlist: item => `${item.type}:${item.handle}`
  };
  const writeList = {
    favorites: items => store.set(KEYS.favorites, items),
    recordings: items => store.set(KEYS.recordings, { version: 1, entries: items }),
    wishlist: items => store.set(KEYS.wishlist, { version: 1, entries: items })
  };

  /* ------------------------------------------------------- Merkliste */
  const isSaved = (type, handle) => lists.wishlist().some(item => item.type === type && item.handle === handle);
  const decorateSaveButtons = (scope = document) => {
    const saved = new Set(lists.wishlist().map(keyOf.wishlist));
    scope.querySelectorAll('[data-asif-club-save]').forEach(button => {
      const on = saved.has(`${button.dataset.type}:${button.dataset.handle}`);
      button.setAttribute('aria-pressed', String(on));
      const title = button.dataset.title || '';
      const label = on ? `Von der Merkliste nehmen: ${title}` : `Merken: ${title}`;
      button.setAttribute('aria-label', label);
      button.title = on ? 'Gemerkt' : 'Merken';
      const text = button.querySelector('[data-asif-save-label]');
      if (text) text.textContent = on ? 'Gemerkt' : 'Merken';
    });
    document.querySelectorAll('[data-club-count="wishlist"]').forEach(node => { node.textContent = String(saved.size); });
  };
  const toggleSaved = (type, handle, title) => {
    let items = lists.wishlist();
    const existing = items.findIndex(item => item.type === type && item.handle === handle);
    let added = false;
    if (existing >= 0) items.splice(existing, 1);
    else {
      items.unshift({ type, handle, title: String(title || '').slice(0, 200), savedAt: Date.now() });
      items = items.slice(0, LIMIT.wishlist);
      added = true;
    }
    writeList.wishlist(items);
    decorateSaveButtons();
    window.dispatchEvent(new CustomEvent('asif:wishlist-change', { detail: { added, type, handle } }));
    return added;
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-asif-club-save]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const { type, handle, title } = button.dataset;
    if (!type || !handle) return;
    toggleSaved(type, handle, title);
  }, true);

  /* ---------------------------------------------------------- Abgleich */
  const KINDS = ['favorites', 'recordings', 'wishlist'];
  const canSync = () => Boolean(cfg.member && cfg.token && cfg.api);
  let inFlight = false, again = false, timer = 0, lastPull = 0, failures = 0;

  // Stand, den dieses Geraet zuletzt mit dem Konto abgeglichen hat. Gehoert er
  // zu einem anderen Konto (geteiltes Geraet), gilt er als fremd: dessen Titel
  // werden nicht ins neue Konto uebernommen, nur was danach dazukam.
  const rawSnapshot = () => store.get(KEYS.snapshot, null);
  const snapshot = () => {
    const snap = rawSnapshot();
    return snap && cfg.customer && String(snap.customer) === String(cfg.customer) ? snap : null;
  };
  const foreignSnapshot = () => {
    const snap = rawSnapshot();
    return snap && snap.customer && cfg.customer && String(snap.customer) !== String(cfg.customer) ? snap : null;
  };
  const opsFor = (kind, snap, foreign) => {
    const local = lists[kind]();
    const known = new Set(snap ? snap[kind] || [] : []);
    const alien = new Set(foreign ? foreign[kind] || [] : []);
    const localKeys = new Set(local.map(keyOf[kind]));
    const add = local.filter(item => !known.has(keyOf[kind](item)) && !alien.has(keyOf[kind](item)));
    const remove = snap ? [...known].filter(key => !localKeys.has(key)) : [];
    return add.length || remove.length ? { add: add.slice(0, 150), remove: remove.slice(0, 150) } : null;
  };
  const collectOps = () => {
    const snap = snapshot();
    const foreign = snap ? null : foreignSnapshot();
    const body = {};
    KINDS.forEach(kind => { const ops = opsFor(kind, snap, foreign); if (ops) body[kind] = ops; });
    return body;
  };
  const localKeys = () => Object.fromEntries(KINDS.map(kind => [kind, lists[kind]().map(keyOf[kind])]));

  // Serverstand uebernehmen. "sent" ist der lokale Stand beim Absenden: was
  // seitdem auf diesem Geraet (oder in einem anderen Tab) gemerkt oder entfernt
  // wurde, bleibt erhalten und geht mit dem naechsten Abgleich raus.
  const applyState = (state, sent = null) => {
    if (!state || typeof state !== 'object') return false;
    const before = JSON.stringify(localKeys());
    let pending = false;
    const next = {};
    KINDS.forEach(kind => {
      const server = Array.isArray(state[kind]) ? state[kind] : [];
      if (!sent) { next[kind] = server; return; }
      const current = lists[kind]();
      const was = new Set(sent[kind]);
      const now = new Set(current.map(keyOf[kind]));
      const added = current.filter(item => !was.has(keyOf[kind](item)));
      const removed = new Set([...was].filter(key => !now.has(key)));
      if (added.length || removed.size) pending = true;
      const seen = new Set();
      next[kind] = [...added, ...server.filter(item => !removed.has(keyOf[kind](item)))]
        .filter(item => { const key = keyOf[kind](item); if (seen.has(key)) return false; seen.add(key); return true; });
    });
    writeList.favorites(next.favorites);
    writeList.recordings(next.recordings);
    writeList.wishlist(next.wishlist);
    store.set(KEYS.snapshot, {
      customer: cfg.customer,
      rev: state.rev || '',
      favorites: (state.favorites || []).map(keyOf.favorites),
      recordings: (state.recordings || []).map(keyOf.recordings),
      wishlist: (state.wishlist || []).map(keyOf.wishlist),
      at: Date.now()
    });
    const after = JSON.stringify(localKeys());
    if (before !== after) {
      window.AsIfRadio?.reloadFavorites?.();
      window.AsIfRadioCollection?.reload?.();
    }
    decorateSaveButtons();
    if (state.reminders) setReminders(state.reminders);
    window.dispatchEvent(new CustomEvent('asif:club-state', { detail: { member: state.member !== false } }));
    return pending;
  };

  // Frisches Token holen (App laenger als einen Tag offen): Clubseite laden und
  // die Konfiguration daraus lesen. Laeuft nur nach einer 401-Antwort.
  const refreshConfig = async () => {
    try {
      const res = await fetch(cfg.clubUrl || '/pages/club', { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'asif-club' } });
      const html = await res.text();
      const match = html.match(/<script id="asif-club-config" type="application\/json">([\s\S]*?)<\/script>/);
      if (!match) return false;
      const next = parseConfig(match[1]);
      if (!next.api) return false;
      cfg = Object.assign({}, cfg, next);
      return Boolean(next.token);
    } catch { return false; }
  };

  const rawRequest = (path, body, keepalive = false) => fetch(`${cfg.api}${path}`, {
    method: body ? 'POST' : 'GET',
    headers: Object.assign({ authorization: `Bearer ${cfg.token}` }, body ? { 'content-type': 'application/json' } : {}),
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'omit',
    keepalive,
    cache: 'no-store'
  }).then(res => (res.ok ? res.json() : Promise.reject(new Error(String(res.status)))));
  const request = (path, body, keepalive = false) => rawRequest(path, body, keepalive).catch(async error => {
    if (error.message !== '401' || !(await refreshConfig())) throw error;
    return rawRequest(path, body, keepalive);
  });

  const sync = async ({ force = false, join = false, keepalive = false } = {}) => {
    if (!cfg.token || !cfg.api) return null;
    if (!canSync() && !join) return null;
    if (inFlight) { again = true; return null; }
    const body = collectOps();
    if (join) {
      body.join = true;
      // Woher kommt das Mitglied? Shopseiten -> Shop, alles andere -> Radio.
      // Daraus entscheiden die Mail-Ablaeufe, wer Kauf-Mails bekommt (Pierre 25.09.).
      const from = session.get(KEYS.from) || '';
      body.source = /^\/(products|collections|cart|search)(\/|\?|$)/.test(from) ? 'shop' : 'radio';
    }
    const snap = snapshot();
    const hasOps = Object.keys(body).length > 0;
    if (!hasOps && !force && snap && snap.rev === (cfg.rev || '')) return null;
    inFlight = true;
    const sent = localKeys();
    try {
      const state = await request(hasOps ? '/sync' : '/state', hasOps ? body : null, keepalive);
      cfg.rev = state.rev || '';
      lastPull = Date.now();
      failures = 0;
      if (applyState(state, sent)) again = true;
      return state;
    } catch (error) {
      // Kein Netz oder Server kurz weg: Aenderungen bleiben lokal und der
      // Abgleich versucht es spaeter noch einmal (5 s, 20 s, 60 s).
      if (hasOps && failures < 3 && !join) { schedule([5000, 20000, 60000][failures]); failures += 1; }
      return null;
    } finally {
      inFlight = false;
      if (again) { again = false; schedule(400); }
    }
  };
  const schedule = (delay = 1200) => {
    if (!canSync()) return;
    clearTimeout(timer);
    timer = setTimeout(() => sync(), delay);
  };
  // Zurueck aus dem Hintergrund (App, anderer Tab): Stand vom Konto holen,
  // hoechstens alle 15 Sekunden.
  const pull = () => {
    if (!canSync() || Date.now() - lastPull < 15000) return;
    lastPull = Date.now();
    sync({ force: true });
  };

  /* ------------------------------------------- Erinnerungen fuers Konto */
  // Welche Sendungen ein Mitglied gemerkt hat, liegt im Konto. Der Club-Server
  // traegt jede Aenderung auch auf den anderen Geraeten ein, die Push erlaubt
  // haben. Ein Geraet ohne Freigabe zeigt die Glocke als gemerkt und bietet an,
  // Push hier einzuschalten (die Freigabe gibt es nur pro Geraet).
  const REM_KEY = 'asif.club.reminders.v1';
  const DEVICE_KEY = 'asif.club.reminder-device.v1';
  let accountReminders = null;
  const cleanReminders = value => (value && typeof value === 'object' ? {
    series: Array.isArray(value.series) ? value.series.filter(i => i && i.programHandle) : [],
    once: Array.isArray(value.once) ? value.once.filter(i => i && i.programHandle && Date.parse(i.endsAt) > Date.now()) : []
  } : null);
  const setReminders = value => {
    const next = cleanReminders(value);
    if (!next) return;
    const changed = JSON.stringify(next) !== JSON.stringify(accountReminders);
    accountReminders = next;
    store.set(REM_KEY, { customer: cfg.customer, list: next });
    if (changed) document.dispatchEvent(new CustomEvent('asif:reminder-ui'));
  };
  const initReminders = () => {
    if (!cfg.member) { accountReminders = null; return; }
    const cached = store.get(REM_KEY, null);
    accountReminders = cleanReminders(cfg.reminders) || (cached && String(cached.customer) === String(cfg.customer) ? cleanReminders(cached.list) : null) || { series: [], once: [] };
  };
  initReminders();
  const deviceLabel = () => {
    const ua = navigator.userAgent || '';
    const standalone = (() => { try { return matchMedia('(display-mode: standalone)').matches || navigator.standalone === true; } catch { return false; } })();
    const kind = /iPhone/.test(ua) ? 'iPhone' : /iPad/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) ? 'iPad' : /Android/.test(ua) ? 'Android' : /Mac/.test(ua) ? 'Mac' : /Windows/.test(ua) ? 'Windows' : 'Browser';
    return standalone ? `${kind} App` : kind;
  };
  const reminderRequest = async payload => {
    if (!canSync()) return null;
    try {
      const state = await request('/reminders', payload);
      if (state?.reminders) setReminders(state.reminders);
      if (state?.rev) { cfg.rev = state.rev; const snap = snapshot(); if (snap) store.set(KEYS.snapshot, Object.assign({}, snap, { rev: state.rev })); }
      return state;
    } catch { return null; }
  };
  // Aenderung auf diesem Geraet (asif-radio-reminders.js meldet sie).
  document.addEventListener('asif:reminder-change', event => {
    const d = event.detail || {};
    if (!canSync() || !d.action) return;
    const payload = { op: { action: d.action, mode: d.mode === 'always' ? 'always' : 'once', programHandle: d.programHandle || d.occurrence?.programHandle, occurrence: d.occurrence || null, title: d.title || '' } };
    if (d.token && d.subscription) payload.device = { token: d.token, subscription: d.subscription, label: deviceLabel() };
    // Sofort anzeigen, der Server bestaetigt gleich.
    if (accountReminders) {
      const h = payload.op.programHandle;
      const next = { series: accountReminders.series.slice(), once: accountReminders.once.slice() };
      if (d.action === 'set' && payload.op.mode === 'always') { next.once = next.once.filter(i => i.programHandle !== h); if (!next.series.some(i => i.programHandle === h)) next.series.push({ programHandle: h, title: payload.op.title }); }
      else if (d.action === 'set' && d.occurrence) { next.series = next.series.filter(i => i.programHandle !== h); next.once.push({ ...d.occurrence, title: payload.op.title }); }
      else if (d.action === 'cancel' && payload.op.mode === 'always') next.series = next.series.filter(i => i.programHandle !== h);
      else if (d.action === 'cancel' && d.occurrence) next.once = next.once.filter(i => !(i.programHandle === h && Date.parse(i.startsAt) === Date.parse(d.occurrence.startsAt)));
      setReminders(next);
    }
    reminderRequest(payload);
  });
  // Dieses Geraet hat Push erlaubt: beim Konto melden. Einmal am Tag mit allen
  // Erinnerungen des Kontos, damit auch nach abgelaufenem Abo alles da ist.
  document.addEventListener('asif:reminder-device', event => {
    const d = event.detail || {};
    if (!canSync() || !d.token || !d.subscription) return;
    const last = store.get(DEVICE_KEY, null);
    const fresh = last && last.customer === String(cfg.customer) && last.token === d.token && last.endpoint === d.subscription.endpoint && Date.now() - last.at < 864e5;
    if (fresh) return;
    reminderRequest({ device: { token: d.token, subscription: d.subscription, label: deviceLabel() }, merge: d.merge || null, full: true }).then(state => {
      if (state) store.set(DEVICE_KEY, { customer: String(cfg.customer), token: d.token, endpoint: d.subscription.endpoint, at: Date.now() });
    });
  });

  /* ------------------------------------------------- Hinweise fuer Gaeste */
  const hintState = () => store.get(KEYS.hints, { shown: 0, last: 0 });
  const showHint = () => {
    if (cfg.customer || document.querySelector('.asif-club-toast')) return;
    const state = hintState();
    // Hoechstens dreimal, mit mindestens 36 Stunden Abstand, einmal pro Besuch.
    if (state.shown >= 3 || Date.now() - state.last < 36 * 3600 * 1000 || session.get('asif.club.hinted')) return;
    // Gemeinsamer Hinweis-Verkehr: nicht auf Spaces/Spirits/Studio, nie neben
    // App-Einladung, Cookie-Banner oder offenem Dialog, ein Werbehinweis pro Besuch.
    const nudge = window.AsIfNudge;
    if (nudge && !nudge.claim('club-hinweis', 'marketing')) return;
    session.set('asif.club.hinted', '1');
    store.set(KEYS.hints, { shown: state.shown + 1, last: Date.now() });
    const toast = document.createElement('div');
    toast.className = 'asif-club-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = `<p><strong>Gemerkt.</strong> Aber nur auf diesem Gerät. Im <span class="asif-wordmark">as.if.club</span> hast du es überall.</p>
      <button type="button" class="asif-club-toast__cta" data-asif-club-open="hinweis">Mitglied werden</button>
      <button type="button" class="asif-club-toast__close" aria-label="Hinweis schließen">${ICON.close}</button>`;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-in'));
    let gone = false;
    const remove = () => {
      if (gone) return; gone = true;
      toast.classList.remove('is-in');
      setTimeout(() => { toast.remove(); nudge?.release('club-hinweis'); }, 320);
    };
    toast.querySelector('.asif-club-toast__close').addEventListener('click', remove);
    toast.querySelector('.asif-club-toast__cta').addEventListener('click', remove);
    setTimeout(remove, 9000);
  };

  const onLocalChange = event => {
    if (canSync()) schedule();
    else if (!cfg.customer && event?.detail?.added) showHint();
    refreshClubPage();
  };
  window.addEventListener('asif:favorites-change', onLocalChange);
  window.addEventListener('asif:recordings-change', onLocalChange);
  window.addEventListener('asif:wishlist-change', onLocalChange);
  window.addEventListener('storage', event => {
    if (event.key === KEYS.favorites) window.AsIfRadio?.reloadFavorites?.();
    if (event.key === KEYS.wishlist || event.key === null) decorateSaveButtons();
  });
  const flush = () => {
    if (!canSync()) return;
    const body = collectOps();
    if (Object.keys(body).length) { clearTimeout(timer); sync({ keepalive: true }); }
  };
  window.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); else pull(); });
  window.addEventListener('pageshow', event => { if (event.persisted) pull(); });
  window.addEventListener('online', () => { failures = 0; if (Object.keys(collectOps()).length) schedule(500); else pull(); });

  /* ------------------------------------------------------------ Dialog */
  const ICON = {
    close: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="2"/></svg>',
    heart: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true"><path d="M12 20.5 4.2 12.6A4.6 4.6 0 0 1 10.7 6l1.3 1.3L13.3 6a4.6 4.6 0 0 1 6.5 6.6Z"/></svg>'
  };
  const loginUrl = email => {
    const back = `${cfg.clubUrl || '/pages/club'}?willkommen=1`;
    const params = new URLSearchParams({ return_to: back, locale: 'de', ui_hint: 'full' });
    // login_hint_mode=submit: Shopify schickt den Code sofort und zeigt direkt
    // die Code-Eingabe. So tippt niemand die Mail-Adresse zweimal ein.
    if (email) { params.set('login_hint', email); params.set('login_hint_mode', 'submit'); }
    return `${cfg.loginUrl || '/customer_authentication/login'}?${params.toString()}`;
  };
  const goLogin = email => {
    try { sessionStorage.setItem(KEYS.intent, String(Date.now())); } catch {}
    window.location.assign(loginUrl(email));
  };

  const bindJoinForm = form => {
    if (!form || form._clubBound) return;
    form._clubBound = true;
    form.addEventListener('submit', event => {
      event.preventDefault();
      const input = form.querySelector('input[type=email]');
      const error = form.querySelector('[data-club-join-error], .asif-club-join__error');
      const email = input.value.trim();
      const ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
      if (error) error.hidden = ok;
      input.setAttribute('aria-invalid', String(!ok));
      if (!ok) { input.focus(); return; }
      const button = form.querySelector('button[type=submit]');
      if (button) { button.disabled = true; button.textContent = 'Einen Moment'; }
      if (!location.pathname.startsWith(cfg.clubUrl || '/pages/club')) session.set(KEYS.from, location.pathname + location.search);
      goLogin(email);
    });
  };

  let dialog = null;
  const buildDialog = () => {
    const covers = (cfg.covers || []).slice(0, 9).map(src => `<img src="${esc(src)}" alt="" width="192" height="192" loading="lazy" decoding="async">`).join('');
    const node = document.createElement('dialog');
    node.className = 'asif-club-dialog';
    node.setAttribute('aria-labelledby', 'asif-club-dialog-title');
    node.innerHTML = `
      <div class="asif-club-dialog__bar">
        <button type="button" class="asif-club-dialog__close" data-club-close aria-label="Schließen">${ICON.close}</button>
        <p class="asif-club-dialog__brand"><span class="asif-wordmark">as.if.club</span></p>
      </div>
      <div class="asif-club-dialog__body">
        <div class="asif-club-dialog__cards">
          <section class="asif-club-card">
            <h2 id="asif-club-dialog-title" class="asif-club-card__title" data-club-copy="title">Komm rein.</h2>
            <p class="asif-club-card__text" data-club-copy="text"></p>
            <ul class="asif-club-perks" data-club-copy="perks"></ul>
          </section>
          <section class="asif-club-card asif-club-card--form">
            <form class="asif-club-join" novalidate>
              <label class="asif-club-join__label" for="asif-club-email">Deine Mail-Adresse</label>
              <div class="asif-club-join__row">
                <input id="asif-club-email" name="email" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" required placeholder="name@beispiel.de">
                <button type="submit" class="asif-club-button">Code schicken</button>
              </div>
              <p class="asif-club-join__error" role="alert" hidden>Da fehlt noch was. Schau bitte nach der Mail-Adresse.</p>
              <p class="asif-club-join__note">Kein Passwort. Du bekommst einen Code per Mail. Schon dabei? Gleicher Weg.</p>
              <p class="asif-club-join__alt"><a href="${esc(loginUrl(''))}" data-club-alt-login>Mit Shop anmelden</a> · <a href="${esc(cfg.clubUrl || '/pages/club')}">Mehr über den Club</a></p>
            </form>
          </section>
        </div>
        <div class="asif-club-dialog__art" aria-hidden="true">${covers}</div>
      </div>`;
    node.addEventListener('click', event => {
      if (event.target === node || event.target.closest('[data-club-close]')) node.close();
    });
    bindJoinForm(node.querySelector('form'));
    node.addEventListener('close', () => {
      document.documentElement.classList.remove('asif-club-open');
      window.AsIfNudge?.release(node.dataset.nudge || '');
      node.dataset.nudge = '';
    });
    document.body.appendChild(node);
    return node;
  };
  const PERKS = {
    titles: 'Deine Titel und Mixtapes auf jedem Gerät',
    list: 'Eine Merkliste für Shop und Blog',
    discount: '10&nbsp;% auf die erste Bestellung, ohne Code',
    orders: 'Bestellungen und Rücksendungen an einem Ort'
  };
  const SHOP_SOURCES = ['produktseite', 'vorkauf', 'footer', 'warenkorb'];
  const fillDialog = (node, source) => {
    const shop = SHOP_SOURCES.includes(source);
    const copy = shop ? {
      title: '10&nbsp;% auf die erste Bestellung.',
      text: 'Im Club zieht der Rabatt automatisch, ohne Code. Dazu merkst du dir Produkte und Radio-Titel auf jedem Gerät. Kostet nichts außer deiner Mail-Adresse.',
      perks: ['discount', 'list', 'titles', 'orders']
    } : {
      title: 'Komm rein.',
      text: 'Der Club kostet nichts außer deiner Mail-Adresse. Dafür hast du deine Titel und deine Merkliste auf jedem Gerät, und auf die erste Bestellung gibt es 10&nbsp;%.',
      perks: ['titles', 'list', 'discount', 'orders']
    };
    node.querySelector('[data-club-copy="title"]').innerHTML = copy.title;
    node.querySelector('[data-club-copy="text"]').innerHTML = copy.text;
    node.querySelector('[data-club-copy="perks"]').innerHTML = copy.perks.map(key => `<li>${PERKS[key]}</li>`).join('');
  };

  const openDialog = source => {
    if (cfg.customer) {
      // Angemeldet, aber noch nicht im Club: direkt beitreten, Seite bleibt.
      if (!cfg.member && cfg.token) {
        sync({ join: true }).then(state => { if (state) window.location.reload(); else window.location.assign(cfg.clubUrl || '/pages/club'); });
        return;
      }
      window.location.assign(cfg.clubUrl || '/pages/club');
      return;
    }
    if (!location.pathname.startsWith(cfg.clubUrl || '/pages/club')) session.set(KEYS.from, location.pathname + location.search);
    dialog = dialog && document.body.contains(dialog) ? dialog : buildDialog();
    dialog.dataset.source = source || '';
    fillDialog(dialog, source || '');
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    document.documentElement.classList.add('asif-club-open');
    requestAnimationFrame(() => dialog.querySelector('input')?.focus({ preventScroll: true }));
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('[data-asif-club-open], a.asif-account__signin, a[data-asif-account-login]');
    if (!trigger) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
    event.preventDefault();
    openDialog(trigger.dataset.asifClubOpen || 'konto');
  });

  /* --------------------------------------------------------- Clubseite */
  const priceFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  const productCache = new Map();
  const product = handle => {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
        .then(res => (res.ok ? res.json() : null)).catch(() => null));
    }
    return productCache.get(handle);
  };
  const img = (src, width) => {
    if (!src) return '';
    try {
      const url = new URL(src.startsWith('//') ? `https:${src}` : src, location.origin);
      if (url.hostname.endsWith('shopify.com') || url.pathname.includes('/cdn/shop/')) url.searchParams.set('width', String(width));
      return url.href;
    } catch { return ''; }
  };

  const renderFavorites = (root, limit) => {
    const node = root.querySelector('[data-club-list="favorites"]');
    if (!node) return;
    const items = lists.favorites();
    const recs = lists.recordings();
    root.querySelectorAll('[data-club-count="favorites"]').forEach(n => { n.textContent = String(items.length + recs.length); });
    if (!items.length && !recs.length) {
      node.innerHTML = '<li class="asif-club-empty">Noch leer. Das Herz im Radio füllt diese Liste.</li>';
      return;
    }
    const rows = items.slice(0, limit).map(item => `
      <li class="asif-club-row">
        ${item.artworkUrl ? `<img class="asif-club-row__cover" src="${esc(item.artworkUrl)}" alt="" width="56" height="56" loading="lazy" decoding="async">` : '<span class="asif-club-row__cover asif-club-row__cover--empty" aria-hidden="true"></span>'}
        <span class="asif-club-row__text"><strong>${esc(item.title)}</strong><span>${esc(item.artist)}</span></span>
      </li>`);
    const recRows = recs.slice(0, Math.max(0, limit - rows.length)).map(item => `
      <li class="asif-club-row">
        <span class="asif-club-row__cover asif-club-row__cover--sc" aria-hidden="true"></span>
        <span class="asif-club-row__text"><strong>${esc(item.title)}</strong><span>Mixtape auf SoundCloud</span></span>
      </li>`);
    node.innerHTML = rows.concat(recRows).join('');
  };

  const renderWishlist = async root => {
    const node = root.querySelector('[data-club-list="wishlist"]');
    if (!node) return;
    const items = lists.wishlist();
    root.querySelectorAll('[data-club-count="wishlist"]').forEach(n => { n.textContent = String(items.length); });
    if (!items.length) {
      node.innerHTML = '<li class="asif-club-empty">Noch leer. Das Herz an Produkten und Artikeln merkt sie hier vor.</li>';
      return;
    }
    if (node.hidden) return;
    const token = Symbol('render');
    node._clubRender = token;
    const cards = await Promise.all(items.slice(0, 24).map(async item => {
      const remove = `<button type="button" class="asif-club-save asif-club-save--card" data-asif-club-save data-type="${esc(item.type)}" data-handle="${esc(item.handle)}" data-title="${esc(item.title)}" aria-pressed="true" aria-label="Von der Merkliste nehmen: ${esc(item.title)}">${ICON.heart}</button>`;
      if (item.type === 'article') {
        return `<li class="asif-club-item asif-club-item--article">
          <a class="asif-club-item__link" href="/blogs/${esc(item.handle)}"><span class="asif-club-item__kind">Artikel</span><strong>${esc(item.title || 'Artikel')}</strong></a>${remove}</li>`;
      }
      const data = await product(item.handle);
      if (!data) return `<li class="asif-club-item asif-club-item--gone"><span class="asif-club-item__link"><strong>${esc(item.title || item.handle)}</strong><span>Gerade nicht im Shop</span></span>${remove}</li>`;
      const image = img(data.featured_image, 360);
      const price = priceFormat.format((data.price || 0) / 100);
      return `<li class="asif-club-item">
        <a class="asif-club-item__link" href="${esc(data.url)}">
          ${image ? `<img src="${esc(image)}" alt="" width="180" height="180" loading="lazy" decoding="async">` : ''}
          <strong>${esc(data.title)}</strong><span>${data.available ? price : 'Ausverkauft'}</span>
        </a>${remove}</li>`;
    }));
    if (node._clubRender !== token) return;
    node.innerHTML = cards.join('');
  };

  const refreshClubPage = () => {
    document.querySelectorAll('[data-asif-club-page]').forEach(root => {
      renderFavorites(root, Number(root.dataset.favoritesLimit || 8));
      renderWishlist(root);
    });
  };

  const mountClubPage = () => {
    const root = document.querySelector('[data-asif-club-page]');
    if (!root || root._clubMounted) { refreshClubPage(); return; }
    root._clubMounted = true;
    bindJoinForm(root.querySelector('[data-club-join-form]'));
    const params = new URLSearchParams(location.search);
    const welcome = params.get('willkommen');

    // Zurueck dorthin, wo jemand vor dem Beitritt war.
    const from = session.get(KEYS.from);
    const back = root.querySelector('[data-club-back]');
    if (back && from && from.startsWith('/') && !from.startsWith('//') && !from.startsWith(cfg.clubUrl)) {
      back.href = from; back.hidden = false;
    }

    // Wer ueber den Club-Dialog angemeldet ist, tritt direkt bei.
    if (cfg.customer && !cfg.member && welcome === '1') {
      root.classList.add('is-joining');
      sync({ join: true }).then(state => {
        const url = new URL(location.href);
        url.searchParams.set('willkommen', state ? '2' : '0');
        location.replace(url.href);
      });
      return;
    }
    if (welcome === '2' && cfg.member) {
      root.querySelector('[data-club-welcome]')?.removeAttribute('hidden');
    }
    if (welcome) {
      const url = new URL(location.href);
      url.searchParams.delete('willkommen');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }

    root.addEventListener('click', event => {
      const join = event.target.closest('[data-club-join]');
      if (join) {
        event.preventDefault();
        if (!cfg.customer) { openDialog('clubseite'); return; }
        join.disabled = true;
        join.textContent = 'Einen Moment';
        sync({ join: true }).then(state => {
          if (state) { const url = new URL(location.href); url.searchParams.set('willkommen', '2'); location.replace(url.href); }
          else { join.disabled = false; join.textContent = 'Nochmal versuchen'; }
        });
        return;
      }
      const leave = event.target.closest('[data-club-leave]');
      if (leave) {
        event.preventDefault();
        if (leave.dataset.confirm !== '1') {
          leave.dataset.confirm = '1';
          leave.textContent = 'Wirklich austreten? Nochmal tippen.';
          return;
        }
        leave.disabled = true;
        request('/leave', {}).then(() => {
          try { localStorage.removeItem(KEYS.snapshot); } catch {}
          location.replace(location.pathname);
        }).catch(() => { leave.disabled = false; leave.textContent = 'Hat nicht geklappt. Nochmal versuchen'; });
      }
    });
    refreshClubPage();
  };

  /* -------------------------------------------------------------- Start */
  const onPage = () => {
    decorateSaveButtons();
    mountClubPage();
    // Beitritts-Formulare ausserhalb der Clubseite (Fuss, Produktseiten-Modul).
    // Ohne Skript schicken sie per GET direkt zur Shopify-Anmeldung.
    document.querySelectorAll('[data-club-join-form]').forEach(bindJoinForm);
  };
  // Weicher Seitenwechsel: neue Konfiguration lesen (an- oder abgemeldet,
  // beigetreten, frisches Token, neue Rev von einem anderen Geraet).
  document.addEventListener('asif:page', event => {
    if (event.detail && event.detail.initial === false) {
      const next = readConfig();
      if (next.api) {
        const changed = next.customer !== cfg.customer || next.member !== cfg.member || (next.rev || '') !== (cfg.rev || '');
        cfg = next;
        if (changed) initReminders();
        if (changed && canSync()) sync();
      }
    }
    onPage();
  });
  document.addEventListener('shopify:section:load', onPage);
  window.addEventListener('asif:collection-change', () => refreshClubPage());

  // Automatische Einladung (z. B. Produktseite): nur ueber den Hinweis-Verkehr,
  // nie fuer Angemeldete. Gibt true zurueck, wenn der Dialog wirklich aufging.
  const invite = (source, nudgeId) => {
    if (cfg.customer) return false;
    const nudge = window.AsIfNudge;
    if (nudge && !nudge.claim(nudgeId, 'marketing')) return false;
    openDialog(source);
    if (dialog) dialog.dataset.nudge = nudgeId;
    return true;
  };

  window.AsIfClub = Object.freeze({
    open: openDialog,
    invite,
    isMember: () => Boolean(cfg.member),
    isSaved,
    toggleSaved,
    sync: () => sync({ force: true }),
    reminders: () => (cfg.member && accountReminders ? { series: accountReminders.series.slice(), once: accountReminders.once.slice() } : null)
  });

  onPage();
  if (canSync()) {
    const start = () => sync();
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2500 }); else setTimeout(start, 800);
  }
})();
